import React, { Component } from "react";
import SimpleDate from "../../../../../modules/SimpleDate";
import {
  CONNECTED,
  FU_BY,
  FU_STATUS,
  INITIAL_DATE,
  INITIAL_ERRORS,
  NOT_REQUIRED_STATUS,
} from "../constants";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import moment from "moment";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { validateField } from "../utils";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import { mapToObjectDDL } from "../../../../common/mapper";

export default class CrmFollowUpFollowUpH23 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      followUpData: {
        followUpDate: INITIAL_DATE,
        followUpStatus: null,
        followUpMethod: null,
        connected: null,
        nextAppointmentDate: null,
        followUpResult: null,
        cancelReason: null,
      },
      errors: INITIAL_ERRORS,
      cancelOptions: [],
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const { data } = this.props;
    if (!data) {
      return;
    }

    if (data?.followUpStatus === "DROP") {
      this.fetchCancelOptions();
    }
    this.setState((prevValue) => ({
      ...prevValue,
      followUpData: {
        ...data,
        followUpStatus: FU_STATUS.find(
          (item) => item.value === data.followUpStatus
        ),
        followUpMethod: FU_BY.find(
          (item) => item.value === data.followUpMethod
        ),
        connected: CONNECTED.find((item) => item.value === data.connected),
        cancelReason:
          data?.followUpStatus === "DROP"
            ? mapToObjectDDL(data?.cancelReason?.value, data?.cancelReason?.key)
            : null,
      },
    }));
  };

  setValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      followUpData: {
        ...prevValue.followUpData,
        [name]: value,
      },
    }));
  };

  fetchCancelOptions = async () => {
    console.log(this.props)
    const { onTriggerLoading, setError } = this.props;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
      menuName: "Follow Up CRM H23",
      setError: setError,
      args: {
        paramFilters: { bizparCategory: "DRP_FU", status: "ACTIVE" },
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        cancelOptions: res.data.data.map((item) =>
          mapToObjectDDL(item.value, item.key)
        ),
      });
    }
  };

  setValueFollowUpStatus = (name, value) => {
    const { followUpData } = this.state;
    if (
      NOT_REQUIRED_STATUS.includes(value?.value) &&
      followUpData.nextAppointmentDate
    ) {
      this.setValue("nextAppointmentDate", null);
    }
    this.setValue(name, value);
  };

  setDateToFormat = (date) => {
    return !date ? null : moment(date, "DD-MM-YYYY").format("DD-MM-YYYY");
  };

  handleSubmit = () => {
    const { followUpData } = this.state;
    const { onSubmit } = this.props;
    const errors = validateField(followUpData);

    if (errors) {
      this.setState((prev) => ({ ...prev, errors }));
      return;
    }

    this.setState((prev) => ({ ...prev, errors: this.initialErrorValue }));

    const requestData = {
      status: followUpData.followUpStatus.value,
      connected: followUpData.connected.value,
      method: followUpData.followUpMethod?.value || null,
      cancelReason:
        followUpData.followUpStatus.value === "DROP"
          ? followUpData?.cancelReason?.value
          : null,
      nextAppointmentDate: followUpData.nextAppointmentDate,
      followUpDate: moment().format("DD-MM-YYYY"),
      followUpResult: followUpData.followUpResult,
    };

    onSubmit(requestData);
  };

  handleClickClose = () => {
    this.setState({
      followUpData: {
        followUpDate: INITIAL_DATE,
        followUpStatus: null,
        followUpMethod: null,
        connected: null,
        nextAppointmentDate: null,
        followUpResult: null,
        cancelReason: null,
      },
    });
    this.props.onClickClose();
  };

  render() {
    const { errors, followUpData, cancelOptions } = this.state;
    const { readOnly, visible, onClickClose } = this.props;

    const {
      followUpDate,
      followUpStatus,
      followUpMethod,
      connected,
      nextAppointmentDate,
      followUpResult,
      cancelReason,
    } = followUpData || {};

    const isStatusNotMandatory = NOT_REQUIRED_STATUS.includes(
      followUpStatus?.value
    );

    const content = (
      <React.Fragment>
        <div className="grid grid-2x gap-20px">
          <div id="grid-1">
            <SimpleDate
              name="followUpDate"
              label="Follow Up Date"
              disabled
              date={this.setDateToFormat(followUpDate)}
              onChange={({ value }) => this.setValue("followUpDate", value)}
            />
            <SimpleDDL
              mandatory
              errorMessage={errors?.followUpStatus}
              box="search"
              id="select_options_follow_up_status"
              name="followUpStatus"
              label="Follow Up Status"
              readOnly={readOnly}
              value={followUpStatus}
              options={FU_STATUS}
              onChange={(value, { name }) => {
                this.setValueFollowUpStatus(name, value);
                this.setValue("cancelReason", null);
                if (value?.value === "DROP") {
                  this.fetchCancelOptions();
                }
              }}
            />
            {followUpStatus?.value === "DROP" ? (
              <SimpleDDL
                mandatory
                errorMessage={errors?.cancelReason}
                box="search"
                id="select_options_drop_reason"
                name="cancelReason"
                label="Alasan DROP"
                readOnly={readOnly}
                value={cancelReason}
                options={cancelOptions}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
            ) : (
              <SimpleDDL
                mandatory
                errorMessage={errors?.followUpMethod}
                box="search"
                id="select_options_follow_up_by"
                name="followUpMethod"
                label="Cara Follow Up"
                readOnly={readOnly}
                value={followUpMethod}
                options={FU_BY}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
            )}
            <SimpleDDL
              mandatory
              errorMessage={errors?.connected}
              box="search"
              id="select_options_connected"
              name="connected"
              label="Terhubung/Tidak"
              readOnly={readOnly}
              value={connected}
              options={CONNECTED}
              onChange={(value, { name }) => this.setValue(name, value)}
            />
            <SimpleDate
              mandatory={!isStatusNotMandatory}
              errorMessage={errors?.nextAppointmentDate}
              name="nextAppointmentDate"
              label="Next Appointment Date"
              disabled={readOnly || isStatusNotMandatory}
              date={this.setDateToFormat(nextAppointmentDate)}
              onChange={(value) =>
                this.setValue(
                  "nextAppointmentDate",
                  moment(value).format("DD-MM-YYYY")
                )
              }
            />
          </div>
          <div id="grid-2">
            <SimpleTextArea
              mandatory
              errorMessage={errors?.followUpResult}
              id="input_text_follow_up_result"
              typeInputCase="normal"
              name="followUpResult"
              maxLength={1000}
              label="Hasil Follow Up"
              readOnly={readOnly}
              value={followUpResult}
              onChange={({ target }) => {
                this.setValue(target.name, target.value);
              }}
            />
          </div>
        </div>
        {!readOnly && (
          <FlexView style={{ justifyContent: "end" }}>
            <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
          </FlexView>
        )}
      </React.Fragment>
    );

    if (readOnly) {
      return content;
    }

    return (
      <SimpleModal
        title="Follow Up"
        visible={visible}
        onClickClose={this.handleClickClose}
        styles={{ width: "50%" }}
        content={<ModalContainer>{content}</ModalContainer>}
      />
    );
  }
}
